import { AdaptedConfigType } from './types/StepperPropType';

/* eslint-disable no-restricted-syntax */
const mandatoryStepIds = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
];

const mandatoryStepIds3b = [
    '1',
    '1.7', // Advisory Investor Profile
    '1.8', // Advisory Strategy Selection
    '2', // Overview / Shopping Cart
    '2.1', // Personal Information
    '2.2', // Agent information
    '2.3', //
    '2.4',
    '2.5',
    '2.6',
    '2.7',
    '2.8',
    '2.9',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
];

function extractMatchingIds(steps: AdaptedConfigType[], completedSteps: number[], is3b) {
    const result: AdaptedConfigType[] = [];

    const stepIds = is3b ? mandatoryStepIds3b : mandatoryStepIds;

    function traverse(items: AdaptedConfigType[]) {
        for (const item of items) {
            if (!completedSteps?.includes(+(item.id as string))) {
                if (stepIds.includes(item.id as string)) {
                    result.push(item);
                }
                if (item.children) {
                    traverse(item.children);
                }
            }
        }
    }

    traverse(steps);

    return result;
}

const useGetMandatoryStep = (is3b) => {
    const getMandatoryStep = ({
        step, currentStep, steps, completedSteps,
    } : {step: AdaptedConfigType, currentStep: AdaptedConfigType, steps: AdaptedConfigType[], completedSteps: number[]}) => {
        const mandatorySteps: AdaptedConfigType[] = extractMatchingIds(steps, completedSteps, is3b);

        const selectedMandatoryStep = mandatorySteps?.filter(st => st?.position >= currentStep.position)?.find((stp) => {
            if (+(step?.id as string) > +(stp.id as string)) {
                return true;
            }

            return false;
        });

        return selectedMandatoryStep?.label;
    };

    return { getMandatoryStep };
};

export default useGetMandatoryStep;
